import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { environment } from 'src/environments/environment';
import { LocalStorageService } from 'src/app/shared/service/local-storage.service';



// Check Before Login New
export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.getToken()) {
    router.navigate(['/vendor/login']);
    return false; // Block navigation if the user is not authenticated.
  }

  return true; // Allow navigation if the user is authenticated.
};

// Check after Login NEW
export const authGuardafterLogin: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const localStorageService = inject(LocalStorageService);

  const hasToken = authService.getToken();
  const isVendorRoute = ['vendor', 'vendor/login'].includes(route.routeConfig?.path || '');
  const hasQueryParams = !!(route.queryParams.token && route.queryParams.lang);

  if (hasToken && isVendorRoute) {
    if (!hasQueryParams) {
      router.navigate(['/dashboard']);
      return false; // Block navigation to vendor routes without required query params.
    }

    if (hasQueryParams) {
      if (environment.production) {
        // Code for DIff domain
        localStorageService.clear();
      } else {
        // Code for same domain
        localStorageService.removeItem('token');
        localStorageService.removeItem('selectedStore');
      }
      router.navigateByUrl(state.url); // Redirect to the same URL with fresh state.
      return false; // Block the initial navigation.
    }
  }

  return true; // Allow navigation if no conditions are met.
};

